import { v4 as uuidv4 } from "uuid";
import cogImagePlaceholder from "@circle-react-shared/BuilderUI/Assets/icons/cog_placeholder_big.png";
import discountImagePlaceholder from "@circle-react-shared/BuilderUI/Assets/icons/discount_placeholder_big.png";
import dollarImagePlaceholder from "@circle-react-shared/BuilderUI/Assets/icons/dollar_placeholder_big.png";
import usersImagePlaceholder from "@circle-react-shared/BuilderUI/Assets/icons/users_placeholder_big.png";
import type { BaseBlock } from "@circle-react-shared/BuilderUI/DataModel.types";
import { createItemCardBlock } from "@circle-react-shared/BuilderUI/DefaultBlocks/utils/layoutBlockHelpers/itemCardBlockHelper";
import { getBlockSecondaryStyleOptions } from "@circle-react-shared/BuilderUI/DefaultBlocks/utils/stylesHelpers";
import {
  createButtonBlock,
  createH2Block,
  createPBlock,
} from "@circle-react-shared/BuilderUI/DefaultBlocks/utils/textBlocksHelpers";
import {
  getBackgroundColorOptions,
  getBorderRadiusOptions,
} from "@circle-react-shared/BuilderUI/utils/buttonStyleHelpers";

const iconBulletStyles = {
  backgroundColor: getBackgroundColorOptions({
    defaultValue: "var(--theme-website-color-6)",
  }),
  borderRadius: getBorderRadiusOptions({
    defaultValue: {
      border_left_top_radius: "100",
      border_left_bottom_radius: "100",
      border_right_top_radius: "100",
      border_right_bottom_radius: "100",
    },
  }),
};

const items = [
  {
    image: {
      signedId: "",
      placeholder: discountImagePlaceholder,
      styles: iconBulletStyles,
    },
    title: "Build a scalable digital offer",
    description: "Use our tools and workflows to deliver a smooth experience.",
  },
  {
    image: {
      signedId: "",
      placeholder: dollarImagePlaceholder,
      styles: iconBulletStyles,
    },
    title: "Launch with clarity and confidence",
    description:
      "Follow our step-by-step launch model to bring your program to life.",
  },
  {
    image: {
      signedId: "",
      placeholder: cogImagePlaceholder,
      styles: iconBulletStyles,
    },
    title: "Deliver your course with ease, not overwhelm",
    description:
      "Set up smart systems that simplify your delivery and elevate the student experience.",
  },
  {
    image: {
      signedId: "",
      placeholder: usersImagePlaceholder,
      styles: iconBulletStyles,
    },
    title: "Grow a brand rooted in transformation—not noise",
    description:
      "Create impactful learning and build a brand known for depth—not just content.",
  },
] as const;

export const defaultData: BaseBlock = {
  id: uuidv4(),
  type: "EvergreenHomepageBlock4",
  props: {
    header: {
      prop: "children",
      type: "children",
      value: [
        createH2Block({
          text: "What you'll build, learn, and launch",
        }),
        createPBlock({
          text: "In this course, you'll go from scattered ideas to a fully structured, market-ready educational product.",
        }),
      ],
    },
    content: {
      prop: "children",
      type: "children",
      value: [...items.map(item => createItemCardBlock(item))],
    },
    button: {
      prop: "children",
      type: "children",
      value: [
        createButtonBlock({
          text: "View full curriculum",
          href: "#",
        }),
      ],
    },
    styles: {
      prop: "styles",
      type: "styles",
      value: {
        ...getBlockSecondaryStyleOptions(),
      },
    },
  },
};
